<template>
  <div class="apply-form">
    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <div v-else-if="!isValid" class="text-center">
      <h1>{{ $t('application.selectInterview.invalid') }}</h1>
    </div>
    <template v-else>
      <div class="text-center">
        <h1>{{ $t('application.selectInterview.title') }}</h1>
      </div>
      <div
        class="apply-form__documents apply-form__section content-box content-box__color-secondary content-box__dense"
      >
        <p>{{ $t('application.selectInterview.info') }}</p>

        <v-radio-group v-model="selected" :readonly="submitting || updated">
          <v-radio
            v-for="suggestion in suggestions"
            :key="suggestion.interviewToken"
            :value="suggestion.interviewToken"
            :label="formatSuggestion(suggestion)"
          />
          <v-radio
            :value="ANOTHER_DATE"
            :label="$t('application.selectInterview.needAnotherDate')"
          />
        </v-radio-group>

        <v-text-field
          flat
          v-model="comment"
          outlined
          hide-details="auto"
          name="comment"
          :label="$t('application.appointmentComment')"
          :readonly="submitting || updated"
        />
      </div>

      <div v-if="!updated" class="d-flex justify-end">
        <v-btn
          @click="submit"
          :loading="submitting"
          :disabled="!selected"
          color="primary"
          class="ml-md-4 mt-4 mt-md-0 d-md-inline"
        >
          {{ $t('submit') }}
          <v-icon class="ml-4">mdi-send</v-icon>
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { eventBus } from '@/event-bus';

const ANOTHER_DATE = 'another';

export default {
  data: () => ({
    applicationId: null,
    authToken: null,
    suggestions: [],
    selected: null,
    comment: '',

    loading: true,
    submitting: false,
    updated: false,
    ANOTHER_DATE
  }),

  computed: {
    isValid() {
      return this.authToken && this.suggestions.length > 0;
    }
  },

  async mounted() {
    this.applicationId = this.$route.params.applicationId;
    this.authToken = this.$route.params.authToken;

    const result = await this.getInterviewSuggestions({
      applicationId: this.applicationId,
      authToken: this.authToken
    });

    if (result && result.success) {
      this.suggestions = result.suggestions || [];
    }

    this.loading = false;
  },

  methods: {
    ...mapActions('applicationModule', {
      getInterviewSuggestions: 'getInterviewSuggestions',
      selectInterviewSuggestion: 'selectInterviewSuggestion'
    }),

    formatSuggestion(suggestion) {
      const start = new Date(suggestion.start);
      const end = new Date(suggestion.end);
      const date = start.toLocaleDateString();
      const from = start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      const to = end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      const location = suggestion.locationName ? ` – ${suggestion.locationName}` : '';
      return `${date}, ${from} - ${to}${location}`;
    },

    async submit() {
      if (!this.selected) {
        return;
      }

      this.submitting = true;
      const needAnotherDate = this.selected === ANOTHER_DATE;
      const response = await this.selectInterviewSuggestion({
        applicationId: this.applicationId,
        authToken: this.authToken,
        interviewToken: needAnotherDate ? null : this.selected,
        needAnotherDate,
        comment: this.comment
      });

      const result = await response.json();
      if (!result.success) {
        eventBus.$emit('errorMessage', this.$t('application.selectInterview.failed'));
      } else {
        eventBus.$emit('successMessage', this.$t('application.selectInterview.success'));
        this.updated = true;
      }

      this.submitting = false;
    }
  }
};
</script>
